<template>
  <v-container class="py-12" max-width="xl">
    <!-- Hero Section -->
    <section class="text-center mb-sm-8 mb-md-12 mb-lg-16">
      <h1
        class="font-weight-bold mb-4 primary--text text-h4 text-sm-h4 text-md-h4 text-lg-h3"
      >
        Century Financial Services
      </h1>
    </section>

    <v-row class="mb-0 mb-md-16" align="stretch">
      <v-col cols="12" md="6">
        <div class="pa-6">
          <h2 class="text-h5 font-weight-bold mb-6 primary--text">
            About Century Financial Services (Pty) Ltd
          </h2>
          <p
            v-for="(listItem, index) in listItems1"
            :key="index + listItem.text"
            v-html="listItem.text"
            class="text-body-1 mb-4"
          ></p>
        </div>
      </v-col>

      <v-col cols="12" md="6" class="pa-2 pa-md-0 d-none d-md-inline">
        <v-sheet
          class="d-flex align-center justify-center pa-8 rounded-xl bg-grey-lighten-4 w-100 h-100"
          height="100%"
          elevation="0"
        >
          <v-icon size="96" color="primary">mdi-information-outline</v-icon>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row class="mb-0 mb-md-16" align="stretch">
      <v-col cols="12" md="6" class="pa-2 pa-md-0">
        <v-sheet
          class="d-flex align-center justify-center pa-8 rounded-xl bg-grey-lighten-4 w-100 h-100"
          height="100%"
          elevation="0"
        >
          <v-icon size="96" color="primary">mdi-finance</v-icon>
        </v-sheet>
      </v-col>
      <v-col cols="12" md="6" class="pl-10">
        <h2 class="text-h5 font-weight-bold mb-6 primary--text">
          Smart, Simple Loan Applications
        </h2>
        <p
          v-for="(listItem, index) in listItems2"
          :key="index + listItem.text"
          v-html="listItem.text"
          class="text-body-1 mb-4"
        ></p>
      </v-col>
    </v-row>

    <!-- Mission Section -->
    <v-row class="mb-12" align="stretch">
      <v-col cols="12" md="6">
        <div class="pa-6 pa-md-0">
          <h2 class="text-h5 font-weight-bold mb-6 primary--text">
            Our Mission: Expanding Access to Responsible Lending
          </h2>
          <p
            v-for="(listItem, index) in listItems3"
            :key="index + listItem.text"
            v-html="listItem.text"
            class="text-body-1 mb-4"
          ></p>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="pa-2 pa-md-0">
        <v-sheet
          class="d-flex align-center justify-center pa-8 rounded-xl bg-grey-lighten-4"
          height="100%"
          elevation="0"
        >
          <v-icon size="96" color="primary">mdi-lightbulb-outline</v-icon>
        </v-sheet>
      </v-col>
    </v-row>

    <!-- Features Section -->
    <section class="mb-16">
      <h2 class="text-h5 font-weight-bold mb-10 text-center primary--text">
        What Sets Us Apart
      </h2>
      <v-row dense>
        <v-col cols="12" md="4" v-for="(feature, i) in features" :key="i">
          <v-card elevation="3" class="pa-6 text-center">
            <v-icon color="primary" size="48" class="mb-4">{{
              feature.icon
            }}</v-icon>
            <h3 class="text-subtitle-1 font-weight-medium mb-2">
              {{ feature.title }}
            </h3>
            <p class="text-body-2 text-grey-darken-1">
              {{ feature.description }}
            </p>
          </v-card>
        </v-col>
      </v-row>
    </section>

    <!-- Technology Section -->
    <v-sheet class="mb-8 mb-md-16 pa-8 pa-md-12 rounded-xl bg-grey-lighten-4">
      <v-row align="center">
        <v-col cols="12" md="6" order-md="2" class="text-center">
          <v-sheet class="pa-6 rounded-lg elevation-0">
            <v-icon size="72" color="primary" class="mb-2"
              >mdi-chart-bar</v-icon
            >
            <p class="font-weight-medium">Smart Data Analysis</p>
          </v-sheet>
        </v-col>
        <v-col cols="12" md="6" order-md="1">
          <h2 class="text-h5 font-weight-bold mb-4 primary--text">
            Leveraging Fintech to Power Smarter Loans
          </h2>
          <p
            v-for="(listItem, index) in listItems4"
            :key="index + listItem.text"
            v-html="listItem.text"
            class="text-body-1 mb-4"
          ></p>
        </v-col>
      </v-row>
    </v-sheet>

    <!-- Customer Experience Section -->
    <v-row class="mb-16" align="stretch">
      <v-col cols="12" md="6">
        <div class="pa-4 pa-md-0">
          <h2 class="text-h5 font-weight-bold mb-4 primary--text">
            A Seamless Online Experience with Human-Centered Support
          </h2>
          <p
            v-for="(listItem, index) in listItems5"
            :key="index + listItem.text"
            v-html="listItem.text"
            class="text-body-1 mb-4"
          ></p>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <v-sheet
          class="d-flex align-center justify-center pa-8 rounded-xl bg-grey-lighten-4"
          height="100%"
          elevation="0"
        >
          <v-icon size="96" color="primary">mdi-account-group</v-icon>
        </v-sheet>
      </v-col>
    </v-row>

    <!-- Contact Section -->
    <v-sheet
      class="mb-16 pa-8 pa-md-12 rounded-xl bg-primary"
      color=""
      variant="tonal"
    >
      <h2 class="text-h5 font-weight-bold mb-6 text-center primary--text">
        Contact Century Financial Services
      </h2>
      <p
        v-for="(listItem, index) in listItems7"
        :key="index + listItem.text"
        v-html="listItem.text"
        class="text-body-1 mb-4 text-center"
      ></p>

      <v-row justify="center" class="mb-8">
        <v-col cols="12" md="5" class="h-100">
          <v-card
            class="pa-5 text-center h-100 d-flex flex-column justify-center"
          >
            <v-icon size="32" color="primary" class="mb-3">mdi-phone</v-icon>
            <h3 class="text-subtitle-1 font-weight-medium mb-1">Call Us</h3>
            <p>
              <a
                href="tel:+27210541057"
                class="text-decoration-none text-body-1"
              >
                +27 21 054 1057
              </a>
            </p>
          </v-card>
        </v-col>

        <v-col cols="12" md="5" class="h-100">
          <v-card
            class="pa-5 text-center h-100 d-flex flex-column justify-center"
          >
            <v-icon size="32" color="primary" class="mb-3">mdi-email</v-icon>
            <h3 class="text-subtitle-1 font-weight-medium mb-1">Email Us</h3>
            <p class="break-all">
              <a href="mailto:clientsupport@centuryfinancialservices.net">
                clientsupport@centuryfinancialservices.net
              </a>
            </p>
          </v-card>
        </v-col>
      </v-row>
    </v-sheet>

    <!-- Trust Section -->
    <section class="text-center">
      <h2 class="text-h5 font-weight-bold mb-4 primary--text">
        Responsible, Compliant, and Customer-Focused
      </h2>
      <p
        v-for="(listItem, index) in listItems6"
        :key="index + listItem.text"
        v-html="listItem.text"
        class="text-body-1 mb-4"
      ></p>
    </section>
  </v-container>
</template>

<script>
// import DefaultList from "@/components/shared/lists/DefaultList";

export default {
  name: "LimeLoansAboutlime",

  // components: { DefaultList },

  metaInfo: {
    title:
      "Quick and Secure Online Loan Applications - Century Fiancial Services Your Trusted Partner",
    meta: [
      {
        name: "description",
        content:
          "As an emerging player in the digital lending and financial services space, Century Financial Services (Pty) Ltd hereinafter referred to as “Century FS” is committed to delivering fast, secure, and transparent financial solutions to individuals across South Africa. We understand that financial stability is the foundation of a better life, and our mission is to support our clients in achieving just that—with reliable, responsible lending options.",
      },
    ],
  },

  data() {
    return {
      features: [
        {
          icon: "mdi-chart-bar",
          title: "Leveraging Fintech",
          description:
            "As a forward-thinking financial services provider, Century FS uses intelligent data tools and machine learning to make smarter, faster lending decisions. This technology allows us to deliver customized solutions to a wide range of customers while keeping the process fast, secure, and efficient",
        },
        {
          icon: "mdi-account-group",
          title: "Human-Centered Support",
          description:
            "Our real difference is in the people behind the scenes, our online application process is designed for convenience and speed. Century is built on a commitment to outstanding customer service. always available to assist—by phone, email, or online-ensuring that you're guided on every step",
        },
        {
          icon: "mdi-shield-check",
          title: "Responsible & Compliant",
          description: `fully compliant with South African financial regulations, operating under Company Registration Number 2023/140135/07 and National Credit Regulator Registration Number NCRCP 20790 Our operations are built on trust, transparency, and a commitment to fair lending practices.`,
        },
      ],
      listItems1: [
        {
          text: `As an emerging player in the digital lending and financial services space, <strong>Century Financial Services (Pty) Ltd</strong> hereinafter referred to as <strong>“Century FS”</strong> is committed to delivering fast, secure, and transparent financial solutions to individuals across South Africa. We understand that financial stability is the foundation of a better life, and our mission is to support our clients in achieving just that—with reliable, responsible lending options.`,
        },
        {
          text: `Our team has a deep understanding of the financial pressures South Africans face, and we&apos;ve developed innovative loan products that offer both immediate relief and longer-term support. From unexpected expenses to everyday needs, <strong>Century FS</strong></strong> is here to provide financial flexibility when it matters most.`,
        },
      ],
      listItems2: [
        {
          text: `We&apos;ve built a streamlined digital platform that simplifies the loan application process. Applying for a loan with Century FS is quick, straightforward, and completely online—so you can get the financial help you need without delays. Backed by technology and financial know-how, our services are tailored to each client, ensuring a personalized lending experience.`,
        },
        {
          text: `Our focus on accessibility and inclusion drives everything we do. We don&apos;t just offer loans—we provide smart financial tools that empower our customers to take control of their financial journey.`,
        },
      ],
      listItems3: [
        {
          text: `At Century Financial Services, our mission is to bridge the gap between financial need and opportunity. We strive to make short-term and personal loans easily accessible through our tech-enabled platform—offering flexible, ethical lending designed to fit your unique situation.`,
        },
        {
          text: `We&apos;re constantly innovating to improve access and affordability. Every product we offer is built with the customer in mind: clear terms, fair interest rates, and repayment options that work with your income and budget.`,
        },
      ],
      listItems4: [
        {
          text: `As a forward-thinking financial services provider, Century FS uses intelligent data tools and machine learning to make smarter, faster lending decisions. This technology allows us to deliver customized solutions to a wide range of customers while keeping the process fast, secure, and efficient.`,
        },
        {
          text: `But we don&apos;t stop at technology—our real goal is long-term financial empowerment. Through responsible lending and useful financial insights, we help clients build healthier money habits and a more stable future.`,
        },
      ],
      listItems5: [
        {
          text: `Century is built on a commitment to outstanding customer service. While our online application process is designed for convenience and speed, our real difference is in the people behind the scenes. Our dedicated support team is always available to assist—by phone, email, or online—ensuring that you're guided every step of the way.`,
        },
        {
          text: `We know that needing a loan can be stressful. That&apos;s why we&apos;ve created a process that&apos;s as simple and stress-free as possible, backed by a team that truly cares.`,
        },
      ],
      listItems6: [
        {
          text: `Century Financial Services is fully compliant with South African financial regulations, operating under <strong>Company Registration Number 2023/140135/07</strong> and <strong>National Credit Regulator Registration Number NCRCP 20790</strong>`,
        },
        {
          text: `Our operations are built on trust, transparency, and a commitment to fair lending practices.`,
        },
        {
          text: `You can count on us to provide financial solutions that not only meet your immediate needs but also respect your long-term financial wellbeing.`,
        },
      ],
      listItems7: [
        {
          text: `Let&apos;s help you move forward. Whether it&apos;s a quick question or a full application, our team is ready to assist.`,
        },
        {
          text: `Century Financial Services - Empowering Financial Freedom.`,
        },
      ],
    };
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.about-lime {
  .h6 {
    font-family: "Raleway";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
  }
}
</style>
